// extracted by mini-css-extract-plugin
export var limitWidthOnLargeScreens = "Section-title-module--limitWidthOnLargeScreens--U4zkx";
export var subtitle = "Section-title-module--subtitle--GK8sy";
export var subtitleV4 = "Section-title-module--subtitleV4--RifaV";
export var titleV4 = "Section-title-module--titleV4--6nMaH";